module.exports = __webpack_public_path__ + "static/assets/logo.b9b39d37.png";